import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssueDownloadUrlInput,
  CreateIssueDownloadUrlResponse,
  QueryCreateAccidentIssueDocumentDownloadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateAccidentIssueDocumentDownloadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssueDownloadUrlInput]?: CreateIssueDownloadUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse>;
}

// SearchAccidentIssueDocument Service
export const {
  createAccidentIssueDocumentDownloadUrl,
  recreateAccidentIssueDocumentDownloadUrl,
  useCreateAccidentIssueDocumentDownloadUrl,
} = ((): {
  createAccidentIssueDocumentDownloadUrl: ServiceMethod;
  recreateAccidentIssueDocumentDownloadUrl: ServiceMethod;
  useCreateAccidentIssueDocumentDownloadUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(CreateAccidentIssueDocumentDownloadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssueDownloadUrlInput, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse> => {
        const args: QueryCreateAccidentIssueDocumentDownloadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createAccidentIssueDocumentDownloadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createAccidentIssueDocumentDownloadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createAccidentIssueDocumentDownloadUrl: fetch,
    recreateAccidentIssueDocumentDownloadUrl: refetch,
    useCreateAccidentIssueDocumentDownloadUrl: useService,
  };
})();
